import { render } from "./AdminApproval.vue?vue&type=template&id=06226e04&scoped=true"
import script from "./AdminApproval.vue?vue&type=script&lang=js"
export * from "./AdminApproval.vue?vue&type=script&lang=js"

import "./AdminApproval.vue?vue&type=style&index=0&id=06226e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06226e04"]])

export default __exports__